import axios from 'axios';
import { getErrorMessage, showErrorToast, showSuccessToast } from '../utils/toast';

export const FETCH_VPA_REQUEST = 'FETCH_VPA_REQUEST' as const;
export const FETCH_VPA_SUCCESS = 'FETCH_VPA_SUCCESS' as const;
export const FETCH_VPA_FAILURE = 'FETCH_VPA_FAILURE' as const;

export const UPDATE_VPA_DETAIL_REQUEST = 'UPDATE_VPA_DETAIL_REQUEST' as const;
export const UPDATE_VPA_DETAIL_SUCCESS = 'UPDATE_VPA_DETAIL_SUCCESS' as const;
export const UPDATE_VPA_DETAIL_FAILURE = 'UPDATE_VPA_DETAIL_FAILURE' as const;

export const DELETE_VPA_REQUEST = 'DELETE_VPA_REQUEST' as const;
export const DELETE_VPA_SUCCESS = 'DELETE_VPA_SUCCESS' as const;
export const DELETE_VPA_FAILURE = 'DELETE_VPA_FAILURE' as const;

export const CLEAR_STORE = 'CLEAR_STORE' as const;

export const clearStoreAction = () => ({
  type: CLEAR_STORE,
});

export const fetchVPAs = (tenantId: number | string) => async (dispatch: any) => {
  dispatch({ type: FETCH_VPA_REQUEST });
  try {
    const token = localStorage.getItem('accessToken');

    const response = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/mappings?tenantId=${tenantId}&limit=100`,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      method: 'GET',
    });

    dispatch({ type: FETCH_VPA_SUCCESS, payload: response.data });
  } catch (error: any) {
    const msg = getErrorMessage(error, 'Failed to load VPAs');
    dispatch({ type: FETCH_VPA_FAILURE, error: msg });
    showErrorToast(msg);
  }
};

export const addVPA = (
  file: Blob | null,
  vpa: string,
  providerName: string | null,
  status: string,
  merchantName: string | null,
  id: number | string,
  qrString?: string | null,
  mcc?: string | null,
  collectionMode: 'vpa' | 'wallet' = 'vpa',
) => async (dispatch: any) => {
  dispatch({ type: UPDATE_VPA_DETAIL_REQUEST });
  try {
    const token = localStorage.getItem('accessToken');
    const formData = new FormData();

    formData.append('vpa', vpa);
    formData.append('providerName', providerName ?? '');
    formData.append('status', status);
    if (merchantName) formData.append('merchantNameFromVpa', merchantName);
    if (qrString != null) formData.append('qrString', qrString);
    if (mcc != null) formData.append('mcc', mcc);
    if (file) {
      formData.append('storeImage.file', file);
    }

    const response = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/vpas`,
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: formData,
      method: 'POST',
    });

    if (response.status !== 201) {
      const errorData: any = response.data;
      showErrorToast(
        errorData?.message ||
          (collectionMode === 'wallet' ? 'Failed to add wallet address' : 'Failed to create VPA'),
      );
      dispatch({ type: UPDATE_VPA_DETAIL_FAILURE, error: errorData?.message });
      return Promise.reject();
    }

    const finalResponse = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/mappings`,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify({
        tenantId: id,
        vpaId: response.data.vpaId,
      }),
      method: 'POST',
    });

    if (finalResponse.status === 201) {
      showSuccessToast(
        collectionMode === 'wallet' ? 'Wallet address added successfully' : 'VPA added successfully',
      );
      dispatch({ type: UPDATE_VPA_DETAIL_SUCCESS, payload: response.data });
      return Promise.resolve();
    }

    const errorData: any = finalResponse.data;
    const failMsg =
      collectionMode === 'wallet' ? 'Failed to add wallet address' : 'Failed to create VPA';
    showErrorToast(typeof errorData === 'string' ? errorData : errorData?.message || failMsg);
    dispatch({ type: UPDATE_VPA_DETAIL_FAILURE, error: errorData });
    return Promise.reject();
  } catch (error: any) {
    const msg = error?.response?.data?.message || error.message;
    showErrorToast(
      msg ||
        (collectionMode === 'wallet' ? 'Failed to add wallet address' : 'Failed to create VPA'),
    );
    dispatch({ type: UPDATE_VPA_DETAIL_FAILURE, error: error.message });
    return Promise.reject();
  }
};

export const deleteVPA = (tenantId: number | string, vpaId: number | string) => async (dispatch: any) => {
  dispatch({ type: DELETE_VPA_REQUEST });
  try {
    const token = localStorage.getItem('accessToken');

    const response = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/mappings/${tenantId}/${vpaId}`,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      method: 'DELETE',
    });

    if (response.status === 200) {
      dispatch({ type: DELETE_VPA_SUCCESS, payload: vpaId });
      return Promise.resolve();
    }
    const errorData: any = response.data;
    showErrorToast(typeof errorData === 'string' ? errorData : errorData?.message || 'Failed to delete VPA');
    dispatch({ type: DELETE_VPA_FAILURE, error: errorData });
    return Promise.reject();
  } catch (error: any) {
    const msg = error?.response?.data?.message || error.message;
    showErrorToast(msg || 'Failed to delete VPA');
    dispatch({ type: DELETE_VPA_FAILURE, error: error.message });
    return Promise.reject();
  }
};

